import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRef, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import TriggleIcon from './TriggleIcon';
import AnimatedSection from '../AnimatedSection';
import CommonTitle from '../CommonTitle';
import Tabs from '../Tabs';

const Output: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Output');
    const swiperRef = useRef<any>(null);

    const [activeIndex, setActiveIndex] = useState(0);
    const tabs = [
        {
            tabLabel: t('tab1'),
            tabValue: 'a1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026842384-3xlc7i-compressed-Kitchen.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758026942249-4qlc3c-compressed-Kitchen.jpg',
            things: [t('tab1_thing1'), t('tab1_thing2'), t('tab1_thing3'), t('tab1_thing4'), t('tab1_thing5')],
        },
        {
            tabLabel: t('tab2'),
            tabValue: 'a2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026864972-y09mu6-compressed-Living%20Room.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758026951614-iyxkad-compressed-Living%20Room.jpg',
            things: [t('tab2_thing1'), t('tab2_thing2'), t('tab2_thing3'), t('tab2_thing4')],
        },
        {
            tabLabel: t('tab3'),
            tabValue: 'a3',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026877780-dozg92-compressed-Home%20Office.jpg',

            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758026961799-4gmyuq-compressed-Home%20Office.jpg',
            things: [t('tab3_thing1'), t('tab3_thing2'), t('tab3_thing3'), t('tab3_thing4')],
            title: t('tab3_title'),
            desc: t('tab3_desc'),
        },
        {
            tabLabel: t('tab4'),
            tabValue: 'a4',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026890255-sponxi-compressed-Garage.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758275839149-zt94b9-compressed-Garage.jpg',
            things: [t('tab4_thing1'), t('tab4_thing2'), t('tab4_thing3')],
            desc: t('tab4_desc'),
            title: t('tab4_title'),
        },
        {
            tabLabel: t('tab5'),
            tabValue: 'b1',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026901377-ir2fps-compressed-Laundry%20Room.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758026980875-scopvi-compressed-Laundry%20Room.jpg',
            things: [t('tab5_thing1'), t('tab5_thing2'), t('tab5_thing3'), t('tab5_thing4')],
        },
        {
            tabLabel: t('tab6'),
            tabValue: 'b2',
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026914321-47j7zl-compressed-RV%20Camping.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758026990157-7lsfmc-compressed-RV%20Camping.jpg',
            things: [t('tab6_thing1'), t('tab6_thing2'), t('tab6_thing3'), t('tab6_thing4'), t('tab6_thing5')],
            desc: t('tab6_desc'),
            title: t('tab6_title'),
        },
    ];

    const onChange = (item: any, index: number) => {
        setActiveIndex(index);
        swiperRef.current.slideTo(index);
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);

        // tab 滚动
        const targetTabItem = document.querySelectorAll('.output-tabs .eco-tab-item')[index];
        const tabsEle = document.querySelector('.output-tabs .eco-tab-items-move');

        if (!targetTabItem || !tabsEle) return;
        const targetTabItemRect = targetTabItem.getBoundingClientRect();

        const tabsEleRect = tabsEle.getBoundingClientRect();

        tabsEle.scrollBy({
            left: targetTabItemRect.left - tabsEleRect.left - tabsEleRect.width / 2 + targetTabItemRect.width / 2,
            behavior: 'smooth',
        });
    };

    return (
        <div className={styles.Output + ' GtmModuleData-section'} id="Output" data-section-id="d3m-output">
            <EcoSpace hPc="160px" hPad="100px" hH5="60px" />
            <CommonTitle title={t('title')} desc={t('desc')} />

            <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <div className="swiper-output d3m-layout">
                    <Swiper
                        onSwiper={(swiper) => {
                            swiperRef.current = swiper;
                        }}
                        slidesPerView={1}
                        spaceBetween={12}
                        initialSlide={0}
                        onSlideChange={handleSlideChange}
                    >
                        {tabs.map((item, index) => (
                            <SwiperSlide key={index} className={`list-item list-item-${index + 1}`}>
                                <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />
                                <div className="things">
                                    {item.things.map((thing, _index) => (
                                        <div key={_index} className={`thing thing-${index + 1}_${_index + 1}`}>
                                            {thing}

                                            <TriggleIcon className="triggle-icon" />
                                        </div>
                                    ))}

                                    {item.desc && (
                                        <div className="desc-wrapper">
                                            {item.title && <div className="title">{item.title}</div>}
                                            {item.desc && <div className="desc">{item.desc}</div>}
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                        {/* <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} /> */}
                    </Swiper>
                </div>
                {/* <EcoTab className="d3m-tabs d3m-layout output-tabs" activeIndex={activeIndex} items={tabs} onChange={onChange} /> */}
                <div className="d3m-tabs">
                    <Tabs className="tabs-output" tabs={tabs} activeIndex={activeIndex} onChange={onChange} />
                </div>
            </AnimatedSection>

            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
        </div>
    );
};

export default Output;
